// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3467":"49c4ae0cf7b26b3187c7","3640":"cf894fbd9d90d67f049c"}[chunkId] + ".css";
};